import { QueryClient } from '@tanstack/react-query';

import { isApiError, NETWORK_ERROR } from '@/shared/api/errors';

/** 일시적인 오류(네트워크·5xx)만 다시 시도한다 — 4xx 는 다시 보내도 결과가 같다 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false;
  if (!isApiError(error)) return false;
  return error.code === NETWORK_ERROR || error.status >= 500;
}

/**
 * 통계는 하루 한 번 쌓이는 스냅샷이라 자주 다시 받을 필요가 없다.
 * 정산 상태(출금 처리)는 운영이 바꾸므로 화면에 돌아올 때 새로 받는다 (staleTime 1분 + focus refetch).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: shouldRetry,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
